import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';

import { InsightsDrawer } from './InsightsDrawer';

export const InsightsFullDrawerRender = () => {
  const { params } = useQueryParams();

  const entityTagFromParams = params[queryKeys.entityTag];
  const activeDrawer = params[queryKeys.activeDrawer];

  if (entityTagFromParams && activeDrawer === queryValues.insightsFullDrawer) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <InsightsDrawer
          key={entityTagFromParams}
          entityTag={entityTagFromParams}
        />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
